import { CustomAxios } from "@shared/api/axiosClient";

import type { Schemas } from "@shared/api/types";

export type RedmineUser = Schemas["UserDTO"];
export type InvoiceSubmission = Schemas["InvoiceSubmissionDTO"];
export type PreInvoice = Schemas["PreInvoiceDTO"];
export type Invoice = Schemas["InvoiceDTO"];
export type ValidateHours = Schemas["ValidateHoursDTO"];
export type ValidateLastMonth = Schemas["ValidatePreInvoiceLastMonthDTO"];
export type SendInvoiceRequest = Schemas["SendInvoiceDTO"];

// Colaboradores de Redmine para el selector de admin.
export const getRedmineUsers = (): Promise<RedmineUser[]> =>
  CustomAxios.get("admin/user/redmine").then(({ data }) => data);

// Facturas enviadas de un colaborador.
export const getInvoiceSubmissions = (redmineId: number): Promise<InvoiceSubmission[]> =>
  CustomAxios.get(`admin/invoice-submission/${redmineId}`).then(({ data }) => data);

// Prefacturas de un colaborador.
export const getPreInvoices = (redmineId: number): Promise<PreInvoice[]> =>
  CustomAxios.get(`admin/pre-invoice/${redmineId}`).then(({ data }) => data);

// Prefacturas pendientes de un colaborador.
export const getPendingPreInvoices = (redmineId: number): Promise<PreInvoice[]> =>
  CustomAxios.get(`admin/pre-invoice/pending/${redmineId}`).then(({ data }) => data);

// Confirma una prefactura pendiente para generar la factura.
export const confirmPreInvoice = (redmineId: number, preInvoiceId: number): Promise<Invoice> =>
  CustomAxios.get(`admin/pre-invoice/confirm/${redmineId}/${preInvoiceId}`).then(
    ({ data }) => data
  );

// Cancela una prefactura.
export const cancelPreInvoice = (preInvoiceId: number): Promise<PreInvoice> =>
  CustomAxios.get(`pre-invoices/cancel-pre-invoice/${preInvoiceId}`).then(({ data }) => data);

// Crea una prefactura del mes actual.
export const createPreInvoice = (redmineId: number): Promise<PreInvoice> =>
  CustomAxios.get(`admin/pre-invoice/create/${redmineId}`).then(({ data }) => data);

// Crea una prefactura del mes anterior.
export const createPreInvoiceLastMonth = (redmineId: number): Promise<PreInvoice> =>
  CustomAxios.get(`admin/pre-invoice/create-last-month/${redmineId}`).then(({ data }) => data);

// Valida si hay datos del mes anterior antes de generar la prefactura.
export const validateLastMonth = (redmineId: number): Promise<ValidateLastMonth> =>
  CustomAxios.get(`admin/pre-invoice/validate-last-month/${redmineId}`).then(({ data }) => data);

// Valida las horas cargadas antes de generar la prefactura.
export const validateHours = (redmineId: number): Promise<ValidateHours> =>
  CustomAxios.get(`admin/pre-invoice/validate-hours/${redmineId}`).then(({ data }) => data);

// Envía una factura al colaborador (con copia opcional). Reemplaza a la antigua
// SendInvoiceAdminFunction: acá solo va el POST; el prompt de Swal vive en la UI.
export const sendInvoice = (redmineId: number, request: SendInvoiceRequest): Promise<string> =>
  CustomAxios.post(`admin/invoice/send/${redmineId}`, request).then(({ data }) => data);
